import { IResponseGetAllQuizsRowData } from '@apiinterface/IQuiz'
import { Flex, Paper } from '@mantine/core'
import React from 'react'
import { Chart } from 'react-google-charts'

interface Props {
    data: IResponseGetAllQuizsRowData[]
    keyData: keyof IResponseGetAllQuizsRowData
}

const ChartSection: React.FC<Props> = ({ data, keyData }) => {
    const colors = ['#008fcf', '#e6007e', '#72ba6f', '#bf0d0d', '#2f2870']
    // Helper function to calculate counts by person_type
    const calculatePersonTypeCounts = (data: IResponseGetAllQuizsRowData[]) => {
        const counts: Record<string, number> = {}
        data.forEach((item) => {
            const personType = item[keyData]
            if (personType) counts[personType] = (counts[personType] || 0) + 1
        })
        return data.length ? Object.entries(counts) : []
    }

    // Prepare data for the Pie Chart
    const findPercen = (value: number) => {
        let percen = (value / data.length) * 100
        return percen.toFixed(2)
    }
    const pd = calculatePersonTypeCounts(data).map((value) => [
        value[0] + ` (${findPercen(value[1])})%`,
        value[1],
    ])
    const pieChartData = [['Person Type', 'Count'], ...pd]

    const co = data.length
        ? calculatePersonTypeCounts(data).map((value, index) => [
              value[0],
              value[1],
              colors[index],
              value[1].toString(),
          ])
        : [['', 0, '#000000', '']]
    const columnChartData = [
        ['ประเภทบุคคล', 'จำนวน', { role: 'style' }, { role: 'annotation' }],
        ...co,
    ]

    // Create annotations for data values on top of the columns
    const annotations = co.map((value, index) => ({
        textStyle: {
            fontSize: 12, // Adjust the font size as needed
        },
        boxStyle: {
            stroke: 'none', // Remove the border
        },
        datum: {
            rowIndex: index + 1,
            columnIndex: 1, // Index of the count column
        },
        text: value[1].toString(), // Display the count value as text
    }))
    return (
        <Paper>
            <Flex>
                <Chart
                    width={'25vw'}
                    height={'300px'}
                    chartType='ColumnChart'
                    loader={<div>Loading Chart</div>}
                    data={columnChartData}
                    options={{
                        legend: 'none',
                        chartArea: {
                            width: '80%',
                            height: '80%',
                        },
                        vAxis: {
                            minValue: 0,
                        },
                        annotations: {
                            textStyle: {
                                fontSize: 12, // Adjust the font size as needed
                            },
                            boxStyle: {
                                stroke: 'none', // Remove the border
                            },
                            alwaysOutside: true, // Display annotations outside the chart
                            annotations,
                        },
                    }}
                />
                <Chart
                    width={'25vw'}
                    height={'300px'}
                    chartType='PieChart'
                    loader={<div>Loading Chart</div>}
                    data={pieChartData}
                    options={{
                        legend: { position: 'right' }, // Position the legend on the right side
                        pieHole: 0.5,
                        colors: colors,
                        chartArea: {
                            width: '90%',
                            height: '80%',
                        },
                    }}
                />
            </Flex>
        </Paper>
    )
}

export default ChartSection
